var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcoming-col d-flex flex-column justify-space-between pa-5"},[_c('div',[_c('v-img',{staticClass:"d-flex justify-start",attrs:{"src":require("@/assets/logo.png"),"width":"120"}})],1),_vm._t("default"),_c('div')],2)}
var staticRenderFns = []

export { render, staticRenderFns }